import React from 'react';
import Testimonial from '../molecules/Testimonial';
import { testimonials as allTestimonials } from '../../data/testimonials';

const TestimonialSection = ({
  title = 'Happy Players, Happy Parents, Happy Schools',
  items = allTestimonials,
  limit,
  showStars = true,
  className = '',
}) => {
  const visibleItems = limit ? items.slice(0, limit) : items;

  return (
    <section className={`bg-gray-100 py-16 md:py-20 ${className}`.trim()}>
      <div className="dr-container">
        <h2 className="text-3xl md:text-4xl font-black mb-8 text-center">{title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {visibleItems.map((testimonial) => (
            <Testimonial
              key={testimonial.id || testimonial.author}
              text={testimonial.text}
              author={testimonial.author}
              title={testimonial.title}
              organization={testimonial.organization}
              showStars={showStars}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
